<template>
  <dv-border-box-10>
    <div class="main">
      <div class="main-header">
        <h3 style="font-size:40px">人员在场曲线图</h3>
      </div>
      <div ref="bepresent" style="width:95%;height:80%"></div>
    </div>
  </dv-border-box-10>
</template>
<style scoped>
.main {
  width: 100%;
  height: 100%;
  color: #fff;
  position: relative;
  background: rgba(47, 79, 79, 0.1);
  padding-top: 2%;
}
.main-header {
  margin-left: 2%;
}
</style>
<script>
import * as echarts from "echarts/core";
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { LineChart } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  CanvasRenderer,
  UniversalTransition,
]);

export default {
  data() {
    return {
      myChart:{},
    };
  },
  methods:{
    changeData(data,hourRange){
        let option={
               xAxis: {
                  data: hourRange,
                },
              series: [
                {
                  data: data,
                },
              ],
        }
        this.myChart.setOption(option);
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.bepresent, "dark");
    var option = {
      backgroundColor: "",
      tooltip: {
        trigger: "axis",
        formatter: function(unit) {
          return unit[0].value.toLocaleString() + "人";
        },
      },
      extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);",
      legend: {
        textStyle: {
          color: "#fff",
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.hourRange,
        axisLabel: {
          show: true,
          textStyle: {
            color: "#fff",
          },
        },
      },
      yAxis: {
        type: "value",
        splitLine: {
          lineStyle: {
            color: "#fff",
          },
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: "#fff",
          },
        },
      },
      series: [
        {
          lineStyle:{
            normal:{
              color:'#f58220',
              width:4,
            }
          },
          type: "line",
          stack: "Total",
        },
      ],
    };
    this.myChart.setOption(option);
  },
};
</script>
